(() => {
  const initialized = new WeakSet();

  function initialize(root) {
    root.querySelectorAll('.church-contact__form').forEach((form) => {
      if (initialized.has(form)) return;
      initialized.add(form);

      // Enhance the native payload without rewriting inputs or the user's message.
      // Named fields still submit normally if JavaScript is unavailable.
      form.addEventListener('formdata', (event) => {
        const fields = event.formData;
        const firstName = form.querySelector('[data-contact-first-name]');
        const lastName = form.querySelector('[data-contact-last-name]');
        const name = [firstName?.value.trim(), lastName?.value.trim()].filter(Boolean).join(' ');

        if (name) {
          fields.set('contact[name]', name);
          if (firstName) fields.delete(firstName.name);
          if (lastName) fields.delete(lastName.name);
        }

        const selections = [];
        form.querySelectorAll('[data-help-option]').forEach((checkbox) => {
          fields.delete(checkbox.name);
          if (checkbox.checked) selections.push(checkbox.value);
        });
        fields.delete('contact[How can we help?]');
        if (selections.length) fields.set('contact[How can we help?]', selections.join(', '));
      });
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
